import React from 'react';
import { connect } from 'react-redux';

import Button from '../../components/Button/Button';
import ButtonLink from '../../components/ButtonLink/ButtonLink';

import ProgressStepper from '../../components/ProgressStepper/ProgressStepper';
import BaseGrid from '../../components/BaseGrid/BaseGrid';

import {
  nextClickedAction,
} from '../../redux/modules/withdrawal';

import WaterPlantImage from '../../assets/images/withdrawals/water-plant.svg';

import styles from './WithdrawalMiniJourney.css';
import ContactUsContent from '../../components/ContactUsContent/ContactUsContent';
import withPensionExpertTier from '../../util/pensionExpertTier/withPensionExpertTier';

const ImportantConsiderations = ({
  step,
  totalSteps,
  onNext,
  onBack,
  dispatchNextClicked,
  hideContactUs = false,
  nextButtonText = 'I understand',
  isPoolExpert,
  expertRoleTitle,
}) => {
  return (
    <BaseGrid addPensionsTheme>
      <div className={styles.withdrawalsContainer}>
        <div className={styles.progressContainer}>
          <ProgressStepper maxStep={totalSteps} step={step + 1} />
        </div>
        <ButtonLink
          onClick={onBack}
          label="← Back"
        />
        <div className={styles.withdrawalsImageContainer}>
          <img src={WaterPlantImage} alt="plant and pot" />
        </div>
        <h2 className={styles.headingTwo}>{'Please read the following important considerations carefully'}</h2>
        <div className={styles.withdrawalText}>{'Taking money from your pension now will reduce the value of your pension pot, meaning you will have less money to generate a retirement income in the future.'}</div>
        <div className={styles.greenBox}>{'When taking money now, you should carefully consider how you will fund your retirement should the funds in your pension run out.'}</div>
        <div className={styles.withdrawalText}>{'Profile Pensions does not provide advice on the withdrawal of money from your pension plan. We offer a facilitation service only.'}</div>
        <div className={styles.withdrawalText}>{'We will however outline the considerations and potential risks involved when withdrawing money from your pension.'}</div>
        {!hideContactUs && (
          <div className={styles.pensionAdviserContainer}>
            <div className={styles.pensionAdviserCard}>
              <ContactUsContent
                source={'ImportantConsiderations'}
                noExpertContentWrapper={({ children }) => (
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    flexShrink: 'initial',
                    padding: '10px',
                    flexWrap: 'wrap',
                  }}
                  >
                    {children}
                  </div>
                )}
                showButton={false}
                customMessage={(
                  <div className={styles.contactUsInnerContent}>
                    {isPoolExpert
                      ? 'Our Pension Experts team are on hand to help. If you have any questions or want to discuss your withdrawal, '
                      : `Your dedicated ${expertRoleTitle} is on hand to help. If you have any questions or want to discuss your withdrawal, `}
                    <span>
                      <ButtonLink
                        variant="primary"
                        to="/inbox/new-message"
                        search={'?subject=Withdrawal%20Request'}
                        displayAsHref
                        font="inherit"
                        label={isPoolExpert ? 'message us here' : 'message them here'}
                      />
                      {'.'}
                    </span>
                  </div>
                )}
              />
            </div>
          </div>
        )}
        <Button
          size="large"
          label={nextButtonText}
          onClick={() => {
            dispatchNextClicked();
            onNext();
          }}
        />
      </div>
    </BaseGrid>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  dispatchNextClicked: nextClickedAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(
  withPensionExpertTier(ImportantConsiderations),
);
